import React from 'react';

import { Image, Link, Text } from '../../../../../ui-kit';

import '../styles/_logged-user.scss';








const LoggedUser = ({ email, imageUrl, firstName, history }) => {
  const onClickNotYouLink = () => {
    if (history.rootPush) {
      history.rootPush('/cast/not-you');
    } else {
      history.push('/cast/not-you');
    }
  };

  return (
    <div className="logged-user">
      <Image
        height="45px"
        width="45px"
        imageUrl={imageUrl}
        placeholderText={firstName}
        circular
        backgroundSize="cover" />


      <div className="logged-user-info">
        <div className="logged-user-info__header">
          <Text className="logged-user-info__title">Currently logged in as</Text>
          <Text className="logged-user-info__email">{email}</Text>
        </div>

        <Link button onClick={onClickNotYouLink}>Not You?</Link>
      </div>
    </div>);

};

export default LoggedUser;